export const sitePages = [
  {
    text: "Page d'accueil",
    value: "/",
  },
  {
    text: "Page Notre Histoire",
    value: "/histoire",
  },
  {
    text: "Page Nos Produits",
    value: "/produits",
  },
  {
    text: "Page Services",
    value: "/services",
  },
  {
    text: "Page Nos Engagements",
    value: "/engagements",
  },
  {
    text: "Page Collection L&B Prestige",
    value: "/collection-lb",
  },
  {
    text: "Page Blog",
    value: "/blog",
  },
  {
    text: "Page Contact",
    value: "/contact",
  },
  {
    text: "Page Mentions Légales",
    value: "/mentions-legales",
  },
  {
    text: "Page Conditions générales",
    value: "/conditions-generales",
  },
];
